<template>
  <div class="main-container">
    <div class="ap-confirmation-modal">
      <div class="ap-confirmation-modal__body">
        <h3 class="ap-confirmation-modal__title m-b-10">{{ message }}</h3>
        <div class="d-flex flex-space-between confirmation-buttons">
          <app-button :text="'Cancel'" :aria-label="'Cancel'" :handler="closeModal" outlined />
          <app-button :text="'Continue'" :aria-label="'Continue'" :handler="handleContinue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { MAPI_API_TYPE } from "@/utils";

export default {
  name: "APConfirmationModal",
  props: {
    onContinue: Function,
    onClose: Function,
    message: String
  },
  data() {
    return {
      timeOut: null,
      voidPayments: true
    };
  },
  computed: {
    ...mapGetters({
      APIType: "venueSettings/APIType"
    })
  },
  mounted() {
    this.startCloseTimer();
  },
  beforeUnmount() {
    clearTimeout(this.timeOut);

    if (this.APIType === MAPI_API_TYPE) return;
    if (!this.voidPayments) return;

    //void PPI transactions
    this.voidAmenityPayments();
  },
  methods: {
    ...mapActions("cart", ["voidAmenityPayments"]),
    closeModal() {
      this.onClose();
    },

    handleContinue() {
      this.voidPayments = false;
      this.onContinue();
    },

    startCloseTimer() {
      this.timeOut = setTimeout(this.closeModal, 10000);
    }
  }
};
</script>
<style lang="scss" scoped>
.dark {
  a:link {
    color: #ffffff;
  }
  a:visited {
    color: #ffffff;
  }
}

.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.ap-confirmation-modal {
  display: flex;
  justify-content: left;
  flex-flow: column;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: $theme2__fontFamilyPrimary;
  color: $text-color;
  padding: 30px;

  @include respond-to-mobile {
    padding: 10px 20px;
  }

  &__title {
    height: 22px;
    word-wrap: break-word;
    position: relative;
    display: inline-block;
    margin-bottom: 80px;

    @include respond-to-mobile {
      text-align: center;
    }
  }

  &__icon {
    align-self: flex-end;
    cursor: pointer;
    padding: 15px 5px 10px;
  }

  &__body {
    display: block;
    font-size: 20px;
    font-weight: 100;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.65;
    letter-spacing: normal;
    width: 100%;

    @include respond-to-mobile {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
    }

    .confirmation-buttons {
      button:nth-of-type(1) {
        margin-right: 10px;
      }
    }
  }
}
</style>
